/*
 *   Copyright (c) 2021 
 *   All rights reserved.
 */
import events from "./events"
const Timer = {
    interval: null,
    start() {
        if(this.interval) {
            clearInterval(this.interval)
        }
        this.interval = setInterval(() => {
            events.emit("tick")
        }, 1000)
    }
}
export default Timer